import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import api from "../../utils/api";
import {toast} from "react-toastify";

const WiseBerryAPIEnv = process.env.VITE_API_KEY;

export const getAllEmployeeNotes = createAsyncThunk(
  "employee/getAllEmployeeNotes",
  async ({id, page, sortId}, {rejectWithValue}) => {
    // debugger;
    // https://api.wiseberryonline.com.au/api/v1/note?contact=321529&created_by=2055475&type=8
    let res;
    try {
      if (sortId === null) {
        res = await api.get(
          `${WiseBerryAPIEnv}note?created_by=${id}&type=8&page=${page}`
        );
      } else {
        res = await api.get(
          `${WiseBerryAPIEnv}note?contact=${sortId}&created_by=${id}&type=8&page=${page}`
        );
      }

      return res.data;
    } catch (err) {
      // Error handling code
    }
  }
);

export const addEmployeeNotes = createAsyncThunk(
  "employee/addEmployeeNotes",
  async (data, {rejectWithValue}) => {
    const {form, noteId} = data;
    // debugger;
    try {
      if (noteId === null) {
        const res = await api.post(`${WiseBerryAPIEnv}note`, form, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        toast.success(res.data.message);
        return res.data.data;
      } else {
        const res = await api.post(`${WiseBerryAPIEnv}note/${noteId}`, form, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        toast.success(res.data.message);
        return res.data.data;
      }
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error("Please Login, Authorization Denied");
      }
      return rejectWithValue(err.message);
    }
  }
);
export const deleteNotes = createAsyncThunk(
  "employee/deleteNote",
  async (data, {dispatch, rejectWithValue}) => {
    try {
      const res = await api.post(`${WiseBerryAPIEnv}note/bulk-delete`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (res.data.message === "Notes have been deleted successfully") {
        // If the response message is success, we assume all the noteIds sent were deleted successfully.
        dispatch(getAllEmployeeNotesSlice.actions.deleteNotesFromList(data));
      }
      toast.success("Note(s) has been deleted successfully");
      return res.data;
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error("Please Login, Authorization Denied");
      }
      return rejectWithValue(err.message);
    }
  }
);

// bulkDeleteNote({
//   selected_ids: selectedRows.map((column) => column?.id),
// })
// https://api.wiseberryonline.com.au/api/v1/note/bulk-delete
// selected_ids
// :
// [19637454, 19637452, 19637451]
// export function bulkDeleteNote(prams) {
//   return axios.post(NOTE + "/bulk-delete", prams, {
//     headers: {
//       "Content-Type": "application/json",
//     },
//   });
// }

let initialState = {
  employeeNote: [],
  loading: false,
  employeeNoteError: null,
  addNote: {},
  deletedNotes: {},
  deletedNotesError: null,
  loadingDeletedNotes: false,
  addNoteError: null,
  loadingAddNote: false,
};

const getAllEmployeeNotesSlice = createSlice({
  name: "employeeNotes",
  initialState,
  reducers: {
    updateNoteInList: (state, action) => {
      const noteIndex = state.employeeNote.data.findIndex(
        (note) => note.id === action.payload.id
      );
      if (noteIndex !== -1) {
        const updatedNote = {
          ...action.payload,
          contact: state.employeeNote.data[noteIndex].contact,
        };
        state.employeeNote.data[noteIndex] = updatedNote;
      }
    },
    deleteNotesFromList: (state, action) => {
      state.employeeNote.data = state.employeeNote.data.filter(
        (note) => !action.payload.selected_ids.includes(note.id)
      );
    },

    // Other reducers...
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllEmployeeNotes.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllEmployeeNotes.fulfilled, (state, action) => {
        if (action.payload.current_page === 1) {
          // This is the first page, replace the whole data
          state.employeeNote = action.payload;
        } else {
          // This is a subsequent page, append the new data to existing one
          state.employeeNote.data = [
            ...state.employeeNote.data,
            ...action.payload.data,
          ];
          state.employeeNote.current_page = action.payload.current_page;
        }
        state.loading = false;
        state.employeeNoteError = null;
      })

      .addCase(getAllEmployeeNotes.rejected, (state, action) => {
        state.loading = false;
        state.employeeNoteError = action.payload;
        state.employeeNote = [];
      })
      .addCase(addEmployeeNotes.pending, (state) => {
        state.loadingAddNote = true;
      })
      .addCase(addEmployeeNotes.fulfilled, (state, action) => {
        state.addNote = action.payload;
        state.loadingAddNote = false;
        state.addNoteError = null;
      })
      .addCase(addEmployeeNotes.rejected, (state, action) => {
        state.loadingAddNote = false;
        state.addNoteError = action.payload;
        state.addNote = {};
      })
      .addCase(deleteNotes.pending, (state) => {
        state.loadingDeletedNotes = true;
      })
      .addCase(deleteNotes.fulfilled, (state, action) => {
        state.deletedNotes = action.payload;
        state.loadingDeletedNotes = false;
        state.deletedNotesError = null;
      })
      .addCase(deleteNotes.rejected, (state, action) => {
        state.loadingDeletedNotes = false;
        state.deletedNotesError = action.payload;
        state.deletedNotes = {};
      });

    // .addCase(logout.fulfilled, (state, action) => {
    //   // Update state with data from the rejected action
    //   return initialState;
    // });
  },
});

export const {updateNoteInList} = getAllEmployeeNotesSlice.actions;

export default getAllEmployeeNotesSlice.reducer;
